import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


function createData(major, owner, percentage) {
  return { major, owner, percentage };
}

const dataMapping = (data, lang) =>{
  const rows = data.map((row,i) => createData(row["major_shareholder_" + lang], row["ownership_" + lang], row.percentage))
  return rows
}


export default function BasicTable(props) {
  const {data, lang}= props; 
  return (
    <TableContainer className="table-styles">
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell><h2 className="bold"> {(lang === "ar")? "ابرز المساهمين":"Major Shareholders "}</h2></TableCell>
            <TableCell><h2 className="bold"> {(lang === "ar")? "الملكية":"Ownership"}  </h2></TableCell>
            <TableCell><h2 className="bold"> {(lang === "ar")? "النسبة المئوية":"Percentage"}  </h2></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataMapping(data, lang).map((row,i) => (
            <TableRow key={row.major+i}>
              <TableCell>{row.major}</TableCell>
              <TableCell>{row.owner}</TableCell>
              <TableCell>{row.percentage}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
